var showTimerId = null;
var hideTimerId = null;
var helpIcon = null;
var helpIconHeight = null;
var helpIconContent = null;
var helpArticles = null;
var initialized = false;

const HelpDirective = {
    inserted(el, binding, vnode, prevVnode) {

        if (!initialized) initialize();

        let shouldDisplayHelpCode = window.location.href.toLowerCase().includes("showhelp");

        if (shouldDisplayHelpCode) {
            displayHelpCode(el, binding);
        }

        var triggeringElements = _.compact([
            el.querySelector("input[type=\"text\"]"),
            el.querySelector("select"),
            el.querySelector("label")
        ]);

        
        for(var t of triggeringElements) {

            let triggeringElement = t;

            triggeringElement.addEventListener(["mouseover"], e => { 
                
                hideHelpIconNow();
    
                var rect = triggeringElement.getBoundingClientRect();
    
                var helpCode = binding.value.toLowerCase();
                var helpHtml = helpArticles && helpArticles[helpCode] && helpArticles[helpCode].html;

                if (shouldDisplayHelpCode) helpHtml = binding.value;
    
                showTimerId = setTimeout(() => {
                    helpIcon.style.top = rect.top + rect.height/2 - helpIconHeight/2 + "px";
                    helpIcon.style.left = rect.right + 3 + "px";
                    if (helpHtml) { 
                        hide(helpIconContent);
                        show(helpIcon);
                        helpIconContent.innerHTML = helpHtml;
                    }
                    showTimerId = null;
                }, 1000);
            });
    
            triggeringElement.addEventListener(["mouseleave"], e => {
                hideHelpIconWithDelay();
            });

        };
      }
}

function hideHelpIconNow() {
    helpIcon.style.display = "none";
    clearTimers();
}    

function hideHelpIconWithDelay() {
    clearTimers()

    hide(helpIconContent);

    hideTimerId = setTimeout(() => {
        hideHelpIconNow();
        helpIcon.style.display = "none";
        hideTimerId = null;
    }, 1000);
}    

function clearTimers() {
    if (hideTimerId) clearTimeout(hideTimerId);
    hideTimerId = null;
    if (showTimerId) clearTimeout(showTimerId);
    showTimerId = null;
}

function initialize() {
    initialized = true;
    helpIcon = document.getElementById("amf-help-hint-icon");
    show(helpIcon)
    helpIconHeight = helpIcon.getBoundingClientRect().height;
    hide(helpIcon)
    helpIconContent = document.getElementById("amf-help-hint-content");

    helpIcon.addEventListener("mouseover", () => {
        clearTimers();
        show(helpIconContent);
    });

    helpIcon.addEventListener("mouseleave", () => {
        hideHelpIconWithDelay();
    });

    helpIcon.addEventListener("click", () => {
        show(helpIconContent);
    });

    helpIconContent.addEventListener("click", () => {
        hide(helpIconContent);
    });

    romeApi.get("help/all").then(helpContent => {
        helpArticles = {};

        for(var h of helpContent) {
            helpArticles[h.code.toLowerCase()] = h;
        }
    });
}

function displayHelpCode(el, binding)
{ 
    var helpCodeElement = document.createElement("div");
    helpCodeElement.innerHTML = `<span style="color: blue"><i>${binding.value}</i></span>`;
    el.appendChild(helpCodeElement);
}

function show(el) {
    el.style.display = "block";
}

function hide(el) {
    el.style.display = "none";
}

function log(msg) {
    console.log(moment(new Date()).format("mm:ss") + " " + msg);
}

export default HelpDirective;



// WEBPACK FOOTER //
// ./src/framework/utils/help-directive.js